import { SafeInput, Skeleton } from "@src/components";
import { useSwapContext } from "@src/contexts";
import { NUMBER_INPUT_REGEX } from "@src/config";
import { YourCash } from "../YourCash";
import { TokenPanel } from "../TokenPanel";
import { TokenWithChain } from "@src/models";
import { useEffect } from "react";

type Props = {
  type: "destination" | "source";
  tokenType: "cash" | "token";
  fixedToken?: TokenWithChain;
  displayToken?: TokenWithChain;
};

export const AmountPanel = ({
  type,
  tokenType,
  fixedToken,
  displayToken,
}: Props) => {
  const {
    tokenAmount,
    isFetchingRoute,
    cashAmount,
    setCashAmount,
    cashToken,
    token,
    setToken,
    setTokenAmount,
    estimatedTokenOutAmount,
  } = useSwapContext();

  useEffect(() => {
    if (fixedToken && tokenType === "token") {
      setToken(fixedToken);
    }
  }, [fixedToken, setToken, tokenType]);

  return (
    <div className="flex items-center w-full p-5 h-[80px] overflow-hidden">
      <div className="flex flex-col font-medium w-full overflow-hidden">
        {type === "source" ? (
          <div className="flex justify-between gap-2 items-center">
            <div className="flex flex-1">
              <SafeInput
                id="swap-amount-input"
                // NOTE: used in e2e tests — do not remove
                dataTestId="swap-cash-amount-input"
                className={`bg-transparent border-none p-0 text-2xl font-bold placeholder:text-2xl placeholder:lh placeholder:text-text_primary placeholder:text-opacity-60 outline-0 w-full`}
                regex={NUMBER_INPUT_REGEX(
                  tokenType === "cash"
                    ? cashToken?.decimals || 6
                    : token?.decimals || 18,
                )}
                value={tokenType === "cash" ? cashAmount : tokenAmount}
                onChange={(value) => {
                  if (tokenType === "cash") {
                    setCashAmount(value);
                  } else {
                    console.log("tokenAmount", value);
                    setTokenAmount(value);
                  }
                }}
                placeholder={`${tokenType === "cash" ? "$" : ""}0`}
                prefix={tokenType === "cash" ? "$" : ""}
              />
            </div>
            {tokenType === "cash" ? (
              <YourCash
                type={type}
                onMaxClick={(balance) => setCashAmount(balance)}
              />
            ) : (
              <TokenPanel
                token={token!}
                onMaxClick={(balance) => setTokenAmount(balance)}
              />
            )}
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-2 items-center">
              {isFetchingRoute ? (
                <div className="flex flex-col gap-1">
                  <Skeleton className="w-[150px] h-[28px]" />
                </div>
              ) : (
                <div
                  // NOTE: used in e2e tests — do not remove
                  data-testid="estimated-amount"
                  className={`flex flex-1 text-2xl font-bold text-left text-text_primary`}
                >
                  {estimatedTokenOutAmount || 0}
                </div>
              )}
              {tokenType === "cash" ? (
                <YourCash
                  type={type}
                  onMaxClick={(balance) => setCashAmount(balance)}
                />
              ) : (
                <TokenPanel
                  token={displayToken || token!}
                  isTokenFixed={!!fixedToken}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
